import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ProfileProgressBar from './ProfileProgressBar'
import { Loader } from 'react-feather'

const UserProfileCard = ({profilePic,isContractor,profilePercentage, mobileNo, uhid, enrollmentDate, policyExpiryDate, userName, userDesignation,companyLogo }) => {
  return (
    <>
     
      <div className='profileCardBg'>
        <div className='companyLogo'><img src={companyLogo} alt='logo-image'/></div>
        <Row>
          <Col xs={12} lg={4}>
            <div className='profileCardImg'>
              <div className='profileCardImgWrap'>
                <ProfileProgressBar percentage={profilePercentage}/>
                  <div className='profileImg'>
                    <img src={profilePic} alt='image' className='img-fluid'/>
                  </div>
                  <p className='profie-completeTxt'>{profilePercentage}%</p>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={8}>
            <div className='profileCardText'>
              <div className='userNameBlock'>
                <p>{userName}</p>
                <p>{userDesignation}</p>
              </div>
              <p>{isContractor ? 'Mobile No:' : 'SAP No:'} {mobileNo}</p>
               {uhid ? <p>UHID: {uhid} </p> : <p>UHID: Not Avaliable </p> }
              <p>Enrollment Date: {enrollmentDate}</p>
              {policyExpiryDate != null || ' ' && <p>Policy Expiry Date: {policyExpiryDate}</p>}
            </div>
          </Col>
        </Row>

      </div>
    </>
  )
}

export default UserProfileCard